import {
  ConnectorsStatusesType,
  DataSourcesStatusesType,
  ERROR_TOOLTIP_STATUSES,
  PipelinesStatusesType,
} from '@core/models';

export function isDataSourceTooltipDisabled(status: string): boolean {
  return !ERROR_TOOLTIP_STATUSES.DataSources.includes(status.toLowerCase() as DataSourcesStatusesType);
}

export function isConnectorTooltipDisabled(status: string): boolean {
  return !ERROR_TOOLTIP_STATUSES.Connectors.includes(status.toLowerCase() as ConnectorsStatusesType);
}

export function isPipelineTooltipDisabled(status: string): boolean {
  return !ERROR_TOOLTIP_STATUSES.Pipelines.includes(status.toLowerCase() as PipelinesStatusesType);
}
